import { montoLegible } from "../../../utils/facturaCrear";
import { tituloClinico } from "../../../utils/textoClinico";
import "../../../styles/FacturaCrear.css";

/* ============================================================================
   CREAR FACTURA · FASE 2 — barra de acciones en lote

   POR QUÉ EXISTE: se podían agregar 380 procedimientos de un clic y había que
   quitarlos de uno en uno. Agregar en lote sin poder quitar en lote es una
   trampa; esta barra es la mitad que faltaba.

   Aparece sólo cuando hay líneas marcadas y se sienta sobre la tabla, no
   sobre la factura entera: mientras está, se sigue viendo qué se va a quitar.

   NO CALCULA NADA: recibe el número y el importe ya resueltos por
   utils/facturaLote.js, con la misma fórmula que la tabla.
   ========================================================================== */

function IconoQuitar() {
    return (
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor"
             strokeWidth="1.9" strokeLinecap="round" aria-hidden="true">
            <path d="M3 6h18" /><path d="M8 6V4h8v2" />
            <path d="M19 6l-1 14H6L5 6" /><path d="M10 11v6" /><path d="M14 11v6" />
        </svg>
    );
}

export default function BarraLote({
    cuantas,
    importe,
    atajos = [],
    onAtajo,
    onLimpiar,
    onQuitar,
    // FASE 3 rellenará esto. Mientras no llegue, el botón no se pinta: un
    // "Aplicar plan a estos" que en realidad aplicara a TODA la factura sería
    // mentir sobre lo que hace.
    onAplicarPlan = null,
    quitando = false,
}) {
    if (cuantas === 0) return null;

    return (
        <div className="fcrear__lote" role="region" aria-label="Acciones sobre lo seleccionado" data-testid="factura-lote">
            <span className="fcrear__lote-cuenta" data-testid="factura-lote-cuenta">
                <strong>{cuantas}</strong> seleccionado{cuantas === 1 ? "" : "s"}
                <span className="fcrear__lote-importe"> · ${montoLegible(importe)}</span>
            </span>

            {/* Atajos por tipo. Sustituyen la selección, no la suman: es lo que
                significa "seleccionar SOLO los de laboratorio". */}
            {atajos.map((a) => (
                <button
                    key={a.tipo}
                    type="button"
                    className="fcrear__lote-atajo"
                    onClick={() => onAtajo(a.tipo)}
                    data-testid={`factura-lote-atajo-${a.tipo}`}
                >
                    Seleccionar solo los de {tituloClinico(a.tipo).toLocaleLowerCase("es")} ({a.n})
                </button>
            ))}

            <button type="button" className="fcrear__lote-atajo" onClick={onLimpiar} data-testid="factura-lote-limpiar">
                Quitar selección
            </button>

            <span className="fcrear__lote-hueco" />

            {onAplicarPlan && (
                <button
                    type="button"
                    className="fcrear__btn"
                    onClick={onAplicarPlan}
                    data-testid="factura-lote-plan"
                >
                    Aplicar plan a estos
                </button>
            )}

            {/* Rojo porque es destructivo, y dice el número exacto: nadie debe
                pulsar "Quitar" sin saber cuántas líneas se lleva por delante. */}
            <button
                type="button"
                className="fcrear__btn fcrear__btn--peligro"
                onClick={onQuitar}
                disabled={quitando}
                data-testid="factura-lote-quitar"
            >
                <IconoQuitar />
                Quitar {cuantas} de la factura
            </button>
        </div>
    );
}
